export function empreendimentoInfoWindow(empreendimento, marker, currentInfoWindow) {
    if (currentInfoWindow) {
        currentInfoWindow.close();
        currentInfoWindow = null;
    }

    const cep = empreendimento.cep.slice(0, 5) + "-" + empreendimento.cep.slice(5);

    const htmlContent = `
        <div class="custom-infowindow">
            <h3>${empreendimento.nome}</h3>
            <p><strong>Endereço:</strong> 
            ${empreendimento.endereco},
             ${empreendimento.numero} - 
             ${empreendimento.bairro}, 
             ${empreendimento.cidade} - 
             ${empreendimento.estado},
             ${cep}
             </p>
        </div>
    `;

    const position = {
        lat: empreendimento.location.coordinates[1],
        lng: empreendimento.location.coordinates[0]
    };

    const newInfoWindow = new google.maps.InfoWindow({
        content: htmlContent,
        position: position,
    });

    newInfoWindow.open({
        anchor: marker,
        map: window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    });

    return newInfoWindow;
}

export function poloInfoWindow(polo, marker, currentInfoWindow) {
    if (currentInfoWindow) {
        currentInfoWindow.close();
        currentInfoWindow = null;
    }

    let htmlContent = `
        <div>
            <h5>${polo.title}</h5>
            <small>
                <strong>Endereço: </strong>${polo.formatted_address} <br />
            </small>
        </div>
                        `;

    let position = { lat: polo.position.coordinates[1], lng: polo.position.coordinates[0] };

    const newInfoWindow = new google.maps.InfoWindow({
        content: htmlContent,
        position: position,
    });

    newInfoWindow.open({
        anchor: marker,
        map: window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    });

    return newInfoWindow;

}